import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchDataAPI } from '../../helpers/fetchDataAPI';
import { URL_BASE_API } from '../../services/glogal';
import { store } from '../store'


export const loadContactQuestions = createAsyncThunk(
    'contactQuestions/loadContactQuestions',
    async (data) => {
        const url = `${URL_BASE_API}/api/contactquestion/getlistcontactquestions`;
        const token = store.getState().userLogged.token;
        const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        const rsp = fetchDataAPI(
            url,
            {
                field01: userId, 
                field02: data.startDate, 
                field03: data.endDate,
                field04: data.question,
                field05: data.status,
                lang: language
            },
            config
        );
        
        return rsp;
    }
);


export const responseContactQuestions = createAsyncThunk(
    'contactQuestions/responseContactQuestions',
    async (data) => {
        const url = `${URL_BASE_API}/api/contactquestion/responsecontactquestion`;
        const token = store.getState().userLogged.token;
        const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        const rsp = fetchDataAPI(
            url,
            {
                field01: userId, 
                field02: data.contactId, 
                field03: data.answer, 
                lang: language
            },
            config
        );
        
        return rsp;
    }
);